import { motion } from 'framer-motion'
import React, { FC } from 'react'

export const NavigationWorkspaceAnimation: FC<{ isExpanded: boolean }> = ({
  children,
  isExpanded
}) => {
  return (
    <motion.div
      layout
      initial={false}
      animate={
        isExpanded
          ? { height: 'auto', opacity: 1, overflow: 'visible' }
          : { height: 0, opacity: 0, overflow: 'hidden' }
      }
      transition={{
        opacity: { ease: 'circOut' },
        height: { ease: 'circOut' }
      }}
    >
      {children}
    </motion.div>
  )
}
